const navigation = function navigation() {
  const mainNav = document.querySelector('.main-nav');
  const body = document.querySelector('body');
  const menuToggle = document.querySelector('.menu-toggle');
  const menuHeaders = document.querySelectorAll('.main-nav .menu-main-navigation-container ul.menu > li > a');

  const searchEl = document.querySelector('.site-search');
  const searchBtn = document.querySelector('.site-search .lupe');
  const searchInput = document.querySelector('.site-search input');

  const statusMap = {
    isMobile: false,
  };

  window.addEventListener('throttledResize', () => {
    statusMap.isMobile = window.innerWidth < 768;

    if (statusMap.isMobile) {
      mainNav.classList.add('mobile');
    } else {
      mainNav.classList.remove('mobile');
      menuHeaders.forEach((el) => el.nextElementSibling.classList.remove('open'));
    }
  });

  searchBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    searchEl.classList.add('active');
    searchInput.focus();
  });

  searchEl.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  mainNav.addEventListener('click', () => {
    searchEl.classList.remove('active');
    searchInput.value = '';
  });

  menuHeaders.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();

        const submenu = el.nextElementSibling;

        if (submenu.classList.contains('open')) {
          submenu.classList.remove('open');
          return;
        }

      menuHeaders.forEach(_el => _el.nextElementSibling.classList.remove('open'));

      submenu.classList.add('open');
    });
  });

  menuToggle.addEventListener('click', (e) => {
    mainNav.classList.toggle('expanded');
    body.classList.toggle('menu-expanded');

    searchInput.blur();
    searchInput.value = '';
    searchEl.classList.remove('active');
  });
};

module.exports  = navigation;
